import login from './modules/login'
import userSecurityManage from './modules/profile/userSecurityManage'
import screen from './modules/screen'
import permission from './modules/permission'
import mainPageManage from './modules/mainPageManage'
import sysFrontendManage from './modules/system/sysFrontendManage'
import systemAuthManage from './modules/system/systemAuthManage'
//
import rspProjUserManage from './modules/proj/projuser/rspProjUserManage'
import rspCtrAcctManage from './modules/proj/user/rspCtrAcctManage'
import rspProjectManage from './modules/proj/project/rspProjectManage'
import rspProjAssignManage from './modules/proj/project/rspProjAssignManage'
import rspCostColumnManage from './modules/proj/conf/rspCostColumnManage'
import rspFeeNameManage from './modules/proj/conf/rspFeeNameManage'
import confProjCtrAcctManage from './modules/proj/project/confProjCtrAcctManage'
import confProjSettleEntityManage from './modules/proj/project/confProjSettleEntityManage'
import confProjSettlePaymentManage from './modules/proj/project/confProjSettlePaymentManage'
import confProjIncomeEntityManage from './modules/proj/project/confProjIncomeEntityManage'
import confProjAcctPayEntityManage from './modules/proj/project/confProjAcctPayEntityManage'
import confProjAcctReceiveEntityManage from './modules/proj/project/confProjAcctReceiveEntityManage'
import confProjAcctCurEntityManage from './modules/proj/project/confProjAcctCurEntityManage'
//
import transIndexManage from './modules/proj/project/transIndexManage'
import entryStatisticManage from './modules/proj/project/entryStatisticManage'
import opStatManage from './modules/proj/project/opStatManage'
import fundStatManage from './modules/proj/project/fundStatManage'
import accountantFlowTransManage from './modules/proj/project/accountantFlowTransManage'
import confCashierFlowEntityManage from './modules/proj/project/confCashierFlowEntityManage'
import cashierFlowTransManage from './modules/proj/project/cashierFlowTransManage'
import projSettleTransManage from './modules/proj/project/projSettleTransManage'
import projIncomeTransManage from './modules/proj/project/projIncomeTransManage'
import projAcctPayTransManage from './modules/proj/project/projAcctPayTransManage'
import projAcctReceiveTransManage from './modules/proj/project/projAcctReceiveTransManage'
import projAcctCurTransManage from './modules/proj/project/projAcctCurTransManage'
import projSettleInvoiceManage from './modules/proj/project/projSettleInvoiceManage'
import accountantTransManage from './modules/proj/project/accountantTransManage'
// rpt
import projMthRptManage from './modules/proj/rpt/projMthRptManage'
// pd
import pdCostColumnManage from './modules/proj/conf/pdCostColumnManage'
import pdTypeLevelOneManage from './modules/proj/conf/pdTypeLevelOneManage'
import pdNameManage from './modules/proj/conf/pdNameManage'
import rspProjSettleMaterialManage from './modules/proj/project/pdtrans/rspProjSettleMaterialManage'
import rspProjSettleLabourManage from './modules/proj/project/pdtrans/rspProjSettleLabourManage'
import rspProjSettleSubcontractManage from './modules/proj/project/pdtrans/rspProjSettleSubcontractManage'
import rspProjSettleLeaseManage from './modules/proj/project/pdtrans/rspProjSettleLeaseManage'
//
import forgetPwd from './modules/forgetPwd'
import confProjectStepManage from './modules/components/proj/confProjectStepManage'
import actionTrailManage from './modules/audit/actionTrailManage'
import dataAuditManage from './modules/components/audit/dataAuditManage'
import recordHistDataAuditManage from './modules/components/audit/recordHistDataAuditManage'
import sysLogSqlManage from './modules/components/audit/sysLogSqlManage'

export default {
  login,
  userSecurityManage,
  screen,
  permission,
  mainPageManage,
  sysFrontendManage,
  systemAuthManage,
  //
  rspProjUserManage,
  rspCtrAcctManage,
  rspProjectManage,
  rspProjAssignManage,
  rspCostColumnManage,
  rspFeeNameManage,
  confProjCtrAcctManage,
  confProjSettleEntityManage,
  confProjSettlePaymentManage,
  confProjIncomeEntityManage,
  confProjAcctPayEntityManage,
  confProjAcctReceiveEntityManage,
  confProjAcctCurEntityManage,
  //
  transIndexManage,
  entryStatisticManage,
  opStatManage,
  fundStatManage,
  accountantFlowTransManage,
  confCashierFlowEntityManage,
  cashierFlowTransManage,
  projSettleTransManage,
  projIncomeTransManage,
  projAcctPayTransManage,
  projAcctReceiveTransManage,
  projAcctCurTransManage,
  projSettleInvoiceManage,
  accountantTransManage,
  // rpt
  projMthRptManage,
  // pd
  pdCostColumnManage,
  pdTypeLevelOneManage,
  pdNameManage,
  rspProjSettleMaterialManage,
  rspProjSettleLabourManage,
  rspProjSettleSubcontractManage,
  rspProjSettleLeaseManage,
  //
  forgetPwd,
  confProjectStepManage,
  actionTrailManage,
  dataAuditManage,
  recordHistDataAuditManage,
  sysLogSqlManage
}



// WEBPACK FOOTER //
// ./src/store/modules.js